var _desc, _rect, _rect2, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of the Philippines") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Coding according to the official \"description and specification of the FILIPINO flag\" in Executive Order No. 23 from 1936")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 90,
    fill: "#0038a8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 45,
    width: 180,
    height: 45,
    fill: "#ce1126"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 77.942286,45 0,90 0,0",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28,45)",
    fill: "#fcd116"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1,0 L -0.93848823,0.06151177 L 0,0 L -0.93848823,-0.06151177 z",
    transform: "scale(19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M -0.88366349,0.11633651 L -0.83408932,0.16591068 L 0,0 z",
    transform: "scale(19.238092)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "scale(1,-1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "rotate(45)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "rotate(90)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.019238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s",
    transform: "translate(37.961524,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M 5,0 L 1.618034,1.175571 1.545085,4.755283 -0.618034,1.902113 -4.045085,2.938926 -2,0 z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "scale(1,-1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "rotate(-120)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.beb5ee035e68b026702a02922caa8290.svg";
export { ForwardRef as ReactComponent };